import { Individual } from '../models/individual';

export function formatPhoneNumber(phoneNumber: string): string {
  if (phoneNumber) {
    phoneNumber = unformatPhoneNumber(phoneNumber);

    if (phoneNumber.length === 10) {
      const areaCode = phoneNumber.substring(0, 3);
      const exchangeCode = phoneNumber.substring(3, 6);
      const lineNumber = phoneNumber.substring(6);

      if (areaCode && exchangeCode && lineNumber) {
        return `(${areaCode}) ${exchangeCode}-${lineNumber}`;
      }
    }
  }

  return null;
}

export function unformatPhoneNumber(phoneNumber: string): string {
  if (phoneNumber) {
    return phoneNumber.replace(/\D/g, '');
  }

  return null;
}

export function formatPhoneNumbers(individual: Individual) {
  if (individual) {
    individual.mobileNo = formatPhoneNumber(individual.mobileNo);
    individual.phoneNo = formatPhoneNumber(individual.phoneNo);
  }
}

export function unformatPhoneNumbers(individual: Individual) {
  if (individual) {
    individual.mobileNo = unformatPhoneNumber(individual.mobileNo);
    individual.phoneNo = unformatPhoneNumber(individual.phoneNo);
  }
}
